import React from 'react';
import '../assets/css/about.css'
import AboutSwiper from '../components/about-swiper'
// import AboutPart1 from '../components/about/aboutPart1'
// import AboutPart2 from '../components/about/aboutPart2'
import AboutPart3 from '../components/about/aboutPart3'
import AboutPart4 from '../components/about/aboutPart4'
import AboutPart5 from '../components/about/aboutPart5'
import EzBottom from '../components/bottom';
import { AboutCustomDataProvider } from './context/aboutCustomDataProvider';

const About: React.FC = () => {
    return (
        <AboutCustomDataProvider>
            <div className='aboutUs'>
                <AboutSwiper />
                {/* <AboutPart1 /> */}
                {/* <AboutPart2 /> */}
                <AboutPart5 />
                <AboutPart3 />
                <AboutPart4 />
                <EzBottom />
            </div>
        </AboutCustomDataProvider>
    )
};

export default About;   